import { Box,CircularProgress } from '@mui/material';
import React from 'react';

export function Loading() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="200px"
      width="100%"
    >
      <CircularProgress />
    </Box>
  );
} 